// src/data/customCocktails/inventory.js
import { catalogue } from './catalogue';
import { stockOnly } from './stockOnly';

const catalogueAll = [...catalogue, ...stockOnly];

const localeComparator = new Intl.Collator('ja-JP-u-co-unihan', {
  sensitivity: 'base',
});

const deriveTasteSummary = (cocktails) => {
  const tags = new Map();
  cocktails.forEach((cocktail) => {
    cocktail.tasteTags.forEach((tag) => {
      if (!tags.has(tag)) {
        tags.set(tag, 0);
      }
      tags.set(tag, tags.get(tag) + 1);
    });
  });
  return Array.from(tags.entries())
    .sort((a, b) => b[1] - a[1])
    .map(([tag]) => tag);
};

const deriveBaseInventory = () => {
  const baseMap = {
    spirits: new Map(),
    liqueurs: new Map(),
  };

  catalogueAll.forEach((cocktail) => {
    const { baseCategory, baseIngredient } = cocktail;
    if (!baseMap[baseCategory]) {
      baseMap[baseCategory] = new Map();
    }
    if (!baseMap[baseCategory].has(baseIngredient)) {
      baseMap[baseCategory].set(baseIngredient, {
        base: baseIngredient,
        category: baseCategory,
        cocktails: [],
        isOnCurrentMenu: false,
      });
    }
    const entry = baseMap[baseCategory].get(baseIngredient);
    entry.cocktails.push(cocktail);
    if (cocktail.isOnCurrentMenu) {
      entry.isOnCurrentMenu = true;
    }
  });

  return {
    spirits: Array.from(baseMap.spirits.values()).map((entry) => ({
      ...entry,
      tasteTags: deriveTasteSummary(entry.cocktails),
      cocktailCount: entry.cocktails.length,
    })).sort((a, b) => localeComparator.compare(a.base, b.base)),
    liqueurs: Array.from(baseMap.liqueurs.values()).map((entry) => ({
      ...entry,
      tasteTags: deriveTasteSummary(entry.cocktails),
      cocktailCount: entry.cocktails.length,
    })).sort((a, b) => localeComparator.compare(a.base, b.base)),
  };
};

export const baseInventory = deriveBaseInventory();

export const listBaseOptions = (category) => {
  if (category) {
    return baseInventory[category] || [];
  }
  return baseInventory;
};

export const listAllCocktails = () => catalogueAll;
